import DashboardIcon from '../views/components/svgs/DashboardIcon';
import QuestionMarkIcon from '../views/components/svgs/QuestionMarkIcon';
import { ContactUsIcon } from '../views/components/svgs/ContactUsIcon';

export const ICONS = {
    DASHBOARD: DashboardIcon,
    HISTORY: '',
    RESOURCES: '',
    CONTACT_US: ContactUsIcon,
    QUESTION_MARK: QuestionMarkIcon,
    RIGHT_ARROW: '',
};

export default ICONS;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/Icons.tsx